import gql from 'graphql-tag'
import client from '@stores/apollo'

interface ExcludeFromUnseatedMutationInput {
  ids: string[]
  isRemote: boolean
  noDeskNeeded: boolean
}
const toggleExcludeFromUnseated = (input: ExcludeFromUnseatedMutationInput) => {
  return client.gql.mutate({ mutation, variables: { input } })
}

const mutation = gql`
  mutation toggleExcludeFromUnseated($input: ChangeExcludedToEmployeesInput!) {
    changeExcludedToEmployees(input: $input) {
      employees {
        id
      }
    }
  }
`
export default toggleExcludeFromUnseated
